<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'printCards.pdfFormatDialogTitle' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <p class="pc-pdf-format-dialog__desc">
      {{ 'printCards.pdfFormatDialogDesc' | translate }}
    </p>
    <mat-form-field appearance="outline" class="pc-pdf-format-dialog__field">
      <mat-label>{{ 'printCards.pageSize' | translate }}</mat-label>
      <mat-select [formControl]="pageSizePresetControl">
        @for (preset of presets; track preset.id) {
          <mat-option [value]="preset.id">
            {{ preset.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <footer class="app-dialog__footer">
    <button type="button" mat-stroked-button (click)="onCancel()">
      {{ 'cancel' | translate }}
    </button>
    <button type="button" mat-raised-button color="primary" (click)="onConfirm()">
      {{ 'printCards.pdfFormatDialogConfirm' | translate }}
    </button>
  </footer>
</div>
